<template>
  <div
    :id="divId"
    class="AdManager"
    style="min-width: 250px; min-height: 50px"
  />
</template>

<script>
import { toRaw } from 'vue'

export default {
  name: 'AdManagerSlot',
  props: {
    adUnitPath: { type: String, required: true },
    size: {
      type: Array,
      default: () => [
        'fluid',
        [1280, 270],
        [1280, 90],
        [970, 270],
        [970, 90],
        [768, 270],
        [768, 90],
        [468, 90],
        [336, 280],
        [300, 250],
        [300, 75],
        [300, 50],
        [250, 250],
      ],
    },
    divId: {
      type: String,
      default: Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .substring(0, 5),
    },
  },
  data() {
    return {
      definedSlot: undefined,
    }
  },
  mounted() {
    try {
      window.googletag = window.googletag || { cmd: [] }
      this.definedSlot = window.googletag
        .defineSlot(toRaw(this.adUnitPath), toRaw(this.size), toRaw(this.divId))
        .addService(window.googletag.pubads())

      window.googletag.cmd.push(() => {
        window.googletag.display(toRaw(this.divId))
      })
    } catch (e) {
      this.definedSlot = undefined
    }
  },
  beforeUnmount() {
    if (this.definedSlot) {
      window.googletag.destroySlots([toRaw(this.definedSlot)])
    }
  },
}
</script>

<style lang="scss">
.AdManager {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 0 16px 0;
}
</style>
